






























import { Component, Vue } from "vue-property-decorator";
import LotteryView from "./views/Lottery.vue";
import Navigation from "./views/Navigation.vue";
import SettingsBubble from "@/components/SettingsBubble.vue";
import GathererLink from "@/components/GathererLink.vue";

@Component({
    name: "App",
    components: {
      LotteryView,
      Navigation,
      SettingsBubble,
      GathererLink,
    },
})
export default class App extends Vue {
    public spin() {
        const lottery = this.$refs.lottery as LotteryView;

        lottery.startSpin();
    }

    public closeSettings(ev: MouseEvent) {
        if (ev.target instanceof HTMLElement) {
            if (!ev.target.closest(".settingsBubble") && !ev.target.closest(".navLink--settings")) {
                this.$root.$data.settingsOpen = false;
            }
        }
    }
}
